export * from './accordion';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/accordion/index.js
// module id = 850
// module chunks = 3